import React from 'react';

// Lib
import { useEvent } from 'lib/hooks';
import { useAppDispatch } from 'lib/hooks/useDispatch';

// Actions
import { showMessage } from 'reducers/messages';
import * as actionsCreatorThesaurus from 'pages/Thesaurus/reducer';

export function useBioSearchHandler(total: number, content: any[]) {
	const dispatch = useAppDispatch();

	const handlerSubmitGoTo = useEvent((goTo: number) => {
		dispatch(actionsCreatorThesaurus.handlerChangeCurrPage(goTo - 1));
	});

	const onPagePress = useEvent((opt: number) => {
		dispatch(actionsCreatorThesaurus.handlerChangeCurrPage(opt - 1));
	});

	const onNextPressLast = useEvent(() => {
		dispatch(actionsCreatorThesaurus.handlerChangeCurrPage(total - 1));
	});

	const handlerChangeGoTo = useEvent((number: number) => {
		if (number <= content.length) {
			dispatch(actionsCreatorThesaurus.handlerChangeUpdateCurrPage(number));
		} else {
			dispatch(
				showMessage({
					type: 'info',
					text: 'This is the last record'
				})
			);
		}
	});

	const onPrevPressLast = useEvent(() => {
		dispatch(actionsCreatorThesaurus.handlerChangeCurrPage(0));
	});

	const onKeyPress = useEvent((e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			const inputElement = e.target as HTMLInputElement;
			dispatch(actionsCreatorThesaurus.handlerChangeCurrPage(+inputElement.value));
		}
	});

	const handleChangeTypeTab = useEvent((type: string) => {
		dispatch(actionsCreatorThesaurus.handlerChangeTab(type));
	});

	const handlerChangeSize = useEvent((size: number) => {
		dispatch(actionsCreatorThesaurus.handlerChangeSize(size));
	});

	return {
		handlerSubmitGoTo,
		onPagePress,
		onNextPressLast,
		handlerChangeGoTo,
		onPrevPressLast,
		onKeyPress,
		handleChangeTypeTab,
		handlerChangeSize
	};
}
